import { uniq } from "underscore";

export default {
	async loaded(state, data) {
		state.categories = uniq([...data.categories], 'title');
		localStorage.setItem('offer_category_cache', JSON.stringify(state.categories));
		state.loaded = true;
	},
};
